<script>
  import TopBarUser from './TopBarUser'

  export default {
    name: 'top-bar',

    components: {
      TopBarUser
    },

    data () {
      return {
        variant: ''
      }
    },

    props: {
      backTo: String,
      icon: String,
      title: String,
      help: Function
    },

    methods: {
      handleScroll () {
        let position = window.document.documentElement.scrollTop
        this.variant = (position > 50) ? 'dark' : ''
      }
    },

    created () {
      window.addEventListener('scroll', this.handleScroll)
    },

    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<template>
  <b-navbar toggleable="lg" type="dark" :variant="variant" :sticky="true">
    <b-button :to="backTo" v-if="backTo" class="btn-circle">
      <font-awesome-icon :icon="['far', 'chevron-left']"/>
    </b-button>

    <b-navbar-brand v-if="title">
      <font-awesome-icon :icon="['far', icon]" v-if="icon"/>
      <span v-if="title">{{ title }}</span>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"/>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="ml-auto">
        <b-nav-form class="mr-4">
          <slot name="actions"></slot>
        </b-nav-form>

        <b-nav-item href="#" v-if="help" @click="help">
          <font-awesome-icon :icon="['far', 'question-circle']"/>
          Help
        </b-nav-item>

        <top-bar-user/>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<style src="./TopBar.scss" lang="scss"></style>
